import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import type PlannedBreakForm from 'modules/shift_management/lib/forms/PlannedBreakForm'

import FixedBreakInputs from './FixedBreakInputs'
import FlexibleBreakInputs from './FlexibleBreakInputs'

interface Props {
  form: PlannedBreakForm
  error?: string
  newVersion?: boolean
}

const SemiFlexibleBreakInputs = ({ form, error, newVersion = false }: Props) => {
  const localErrors = form.get('start_at').errors || []
  const fieldError = error || localErrors[0] || ''

  return (
    <Box gap="s8">
      <Box gap="s6">
        {!newVersion && (
          <Text.Normal weight="normal" size="200">
            {i18n.t('company_settings.time.breaks.duration')}
          </Text.Normal>
        )}
        {/* Hide error msg here to avoid duplicated messages */}
        <FlexibleBreakInputs form={form} error={fieldError} hideError newVersion={newVersion} />
      </Box>

      <Box gap="s6">
        {!newVersion && (
          <Text.Normal weight="normal" size="200">
            {i18n.t('company_settings.time.breaks.time_frame')}
          </Text.Normal>
        )}
        <FixedBreakInputs form={form} error={fieldError} newVersion={newVersion} />
      </Box>
    </Box>
  )
}

export default SemiFlexibleBreakInputs
